import { LOCALE_ID, ApplicationConfig, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import LocaleEsPe from '@angular/common/locales/es-PE';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';

import { NgbDatepickerI18n, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { ErrorHandlerInterceptor, TokenHandlerInterceptor } from '@core/interceptors';
import { I18n, CustomDatepickerI18n, CustomDatepickerParseFormatter } from '@core/utils';
import { registerLocaleData } from '@angular/common';
registerLocaleData(LocaleEsPe);

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },

    // Currency
    { provide: DEFAULT_CURRENCY_CODE, useValue: '' },

    // Datepicker
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: CustomDatepickerParseFormatter },
    { provide: LOCALE_ID, useValue: 'es-PE' },

    // Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenHandlerInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
  ],
};
